import { type SxProps } from '@mui/material';
import type React from 'react';
import { type PropsWithChildren, forwardRef } from 'react';

import { mergeSxProps } from './Mui/mergeSxProps';
import { Span } from './Span';

export type SpanWithEllipsisProps = PropsWithChildren<{
  sx?: SxProps;
}>;

function SpanWithEllipsisBase(props: SpanWithEllipsisProps, ref: React.Ref<HTMLSpanElement>) {
  const { children, sx, ...otherProps } = props;

  return (
    <Span
      ref={ref}
      {...otherProps}
      sx={mergeSxProps(
        {
          display: 'block',
          width: '100%',
          minWidth: 0,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        },
        sx
      )}
    >
      {children}
    </Span>
  );
}

export const SpanWithEllipsis = forwardRef<HTMLSpanElement, SpanWithEllipsisProps>(
  SpanWithEllipsisBase
);

SpanWithEllipsis.displayName = 'SpanWithEllipsis';
